module.exports = ".team-image{\r\n    margin-right: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/team-development-calendar/team-player-list/player-list.component.css
// module id = ./src/app/pages/team-development-calendar/team-player-list/player-list.component.css
// module chunks = main